<script setup>
import {ref, onBeforeMount, onMounted, watch} from 'vue'

// 替换模式，只支持单选

const props = defineProps({
  // 选项
  options: {
    required: true,
    type: Array,
    default: () => []
  },
})

/*初次加载*/
onBeforeMount(async () => {
  console.log("ytTags onBeforeMount")
  props.options.map(item => {
    item.checked = false
  })
})
const emit = defineEmits(['change'])

// 已选中的数量
const limitCount = ref(0)
/*处理已选中的checkList改变*/
// 因为是替换模式，所以只支持单选
const handleCheckChange = (isCheck, item, index) => {
  console.log()
  const resIndex = props.options.findIndex(i => i.storeGroupId === item.storeGroupId)
  props.options[resIndex].checked = isCheck
  props.options.map((item, index) => {
    item.checked = !!(item.checked && index === resIndex);
  })
  console.log("props.limit", props.limit)
  console.log("limitCount", limitCount.value)
  emit("change", props.options)
};
// 处理反显
const handleReview = (reviewList) => {
  let count = 0
  let tempList = reviewList.map(item => {
    return item?.storeGroupId
  })
  props.options.map(item => {
    if (tempList.includes(item.storeGroupId)) {
      item.checked = true
      count++
    }
  })
  limitCount.value = count
}
defineExpose({
  handleReview
})
</script>

<template>
  <div>
    <el-check-tag class="yt_check_tag" v-for="(item, index) in props.options" :key="`checkTag${index}`" :checked="item.checked" type="primary" @change="(isCheck) => handleCheckChange(isCheck, item, index)">
      {{item.storeGroupName}}
    </el-check-tag>
  </div>
</template>

<style lang="scss" scoped>
.yt_check_tag {
  margin-right: 32px;
  line-height: 44px;
  background: #ECECF4;
  border-radius: 15px;
  box-sizing: border-box;
  padding: 0 25px;
  margin-bottom: 15px;
  font-weight: 400;
}
.yt_check_tag:last-child {
  margin-right: 0;
}
::v-deep(.el-check-tag) {
  font-size: 16px;
}
::v-deep(.el-check-tag.el-check-tag--primary.is-checked){
  background-color: #796CB4;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
}
::v-deep(.el-check-tag.el-check-tag--primary.is-disabled) {
  background: #ECECF4!important;
  color: #909399!important;
}
</style>
